// extracted by mini-css-extract-plugin
export default {"rating":"MI-z","numberOfStars":"NI-z","count":"OI-z","barGraphSpacing":"PI-z","barGraph":"QI-z"};